import { Component, Input } from '@angular/core';
import { APP_MODE, Appointment, BusinessObject, Staff } from '../../../models';
import { BusinessObjectUtils, CustomerUtils } from '../../../utils';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../../pipes';
import { LibCoreLayoutModule } from '../../../ui/core-layout';

@Component({
  selector: 'lib-calendar-appointment-details',
  templateUrl: './calendar-appointment-details.component.html',
  styleUrls: ['./calendar-appointment-details.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, PipesModule, LibCoreLayoutModule],
})
export class CalendarAppointmentDetailsComponent {
  @Input() businessObject: BusinessObject;

  private _appointment: Appointment;
  @Input() set appointment(value: Appointment) {
    this._appointment = value;

    this.totalPrice = CustomerUtils.getTotalPriceOfAppointmentItems(
      this.appointment
    );
    this.totalDuration =
      this.appointment?.estimatedDuration ||
      CustomerUtils.getTotalDurationOfAppointmentItems(this.appointment);
  }
  get appointment(): Appointment {
    return this._appointment;
  }

  @Input() staff: Staff;
  @Input() mode: APP_MODE;

  public totalPrice: number;
  public totalDuration: number;

  public shouldDisplayAdvanceInfo(): boolean {
    return (
      !!this.mode &&
      this.mode !== APP_MODE.BOOKING &&
      this.mode !== APP_MODE.CHECKIN
    );
  }

  public shouldDisplayFullContactData(): boolean {
    return BusinessObjectUtils.shouldDisplayFullContactDataOfCustomer(
      this.businessObject,
      this.mode
    );
  }
}
